const HorizontalDivider = ({ className = "" }: { className?: string }) =>
    <div className={`h-[1px] w-full ${className} bg-gray-300`}></div>

export default HorizontalDivider